export class ReservationsTenantFilter {
    general: string;
    to_date: string;
    from_date: string;
    create_date: string;
    // iu: string;
    vehicleType: string;
    status:string;
}